import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommonSharedModule } from '@common/shared/common-shared.module';

const SHARED_MODULES = [CommonSharedModule, RouterModule];

const SHARED_DIRECTIVES = [];
const SHARED_COMPONENTS = [];

@NgModule({
  imports: [...SHARED_MODULES],
  exports: [...SHARED_MODULES, ...SHARED_COMPONENTS, ...SHARED_DIRECTIVES],
  declarations: [...SHARED_COMPONENTS, ...SHARED_DIRECTIVES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
})
export class AdminSharedModule {
  static forRoot(): ModuleWithProviders<AdminSharedModule> {
    return {
      ngModule: AdminSharedModule,
      providers: [],
    };
  }
}
